import React, { useCallback, useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Spinner, SmileySad } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { VideoBuyShell } from "@/components/videobuy/VideoBuyShell";
import { VideoBuyStage } from "@/components/videobuy/VideoBuyStage";
import { CheckoutSheet } from "@/components/videobuy/CheckoutSheet";
import { CardReturn } from "@/components/videobuy/CardReturn";

export default function VideoSalesPage() {
  const { slug } = useParams();
  const [sp, setSp] = useSearchParams();
  const [page, setPage] = useState(null);
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  const returnTx = sp.get("tx");

  useEffect(() => {
    api.get(`/public/video-pages/${slug}`)
      .then(({ data }) => { setPage(data); document.title = data.title; })
      .catch((e) => setError(e?.response?.status === 410 ? "Esta oferta foi encerrada pelo produtor." : "Página não encontrada."));
  }, [slug]);

  useEffect(() => {
    if (sp.get("canceled")) {
      toast.info("Pagamento cancelado. Você pode tentar novamente quando quiser.", { id: "pay-canceled" });
      setSp({}, { replace: true });
    }
  }, [sp, setSp]);

  const onStart = useCallback(
    (p) => api.post(`/public/video-pages/${slug}/checkout`, { ...p, origin_url: window.location.origin }).then((r) => r.data),
    [slug],
  );
  const pollStatus = useCallback((tx) => api.get(`/public/video-pages/${slug}/status/${tx}`).then((r) => r.data), [slug]);
  const onMockConfirm = useCallback((tx) => api.post(`/public/video-pages/${slug}/confirm-mock/${tx}`).then((r) => r.data), [slug]);

  if (error) {
    return (
      <VideoBuyShell>
        <div className="max-w-md mx-auto text-center py-20" data-testid="video-page-error">
          <SmileySad size={56} className="mx-auto text-[#FFB30F]" weight="duotone" />
          <div className="font-display font-black text-2xl mt-4">{error}</div>
        </div>
      </VideoBuyShell>
    );
  }
  if (!page) {
    return (
      <VideoBuyShell>
        <div className="py-28 flex justify-center" data-testid="video-page-loading"><Spinner size={36} className="animate-spin text-[#FFB30F]" /></div>
      </VideoBuyShell>
    );
  }

  return (
    <VideoBuyShell ownerName={page.owner_name}>
      <VideoBuyStage data={page} onBuy={() => setOpen(true)} />
      <CheckoutSheet
        open={open}
        onClose={() => setOpen(false)}
        productName={page.title}
        price={page.price}
        acceptPix={page.accept_pix !== false}
        acceptCard={!!page.accept_card}
        onStart={onStart}
        pollStatus={pollStatus}
        onMockConfirm={onMockConfirm}
      />
      {returnTx && <CardReturn txId={returnTx} pollStatus={pollStatus} onDismiss={() => setSp({}, { replace: true })} />}
    </VideoBuyShell>
  );
}
